export default __webpack_public_path__ + "static/HTH_MOBILE-36d3e35b36deff6e2313ebc22a2db391.jpg";